import React,{useEffect} from 'react';
// import Video from '../../videos/vid.mp4';


import { Button, Carousel, Col, Container, Form, FormControl, FormGroup, FormLabel, NavLink, Row } from 'react-bootstrap';


import classic2 from '../../images/classic room converted/classic2.jpg';
import classic33 from '../../images/classic room converted/classic3.jpg';
import classic4 from '../../images/classic room converted/classic4.jpg';
import ClassicVid from '../../videos/ClassicVideo02.mp4';
import {IoIosArrowBack} from 'react-icons/io';
import { HashLink as Link } from 'react-router-hash-link';
import Aos from "aos";
import "aos/dist/aos.css";

import './LuxRoom.css';

function LuxRoomPage() {

  useEffect(() => {
    window.scrollTo(0,0)
    Aos.init({duration:2000});
  }, []);


    return (
        <div>
            <section  className='HeaderPageWrapper'>
                {/* <img src={classic3} alt='tof' className='luxRoom' /> */}
                <a href='https://www.youtube.com/watch?v=x8tNTT6KG8Q'>
                    <video className='videoTag' autoPlay loop muted >
                        <source src={ClassicVid} type='video/mp4' />
                    </video>
                </a>
                <div className='headerWrapper'>
                    <h1>CLASSIC DOUBLE ROOMS </h1>
                </div> 
            </section>
        <section className='DiscoverBody'>  
            <section id='lux' className='MovingCard1'>
            <div className='PrevBox'>
                <Link to='/discover/#classic' className='Previous' ><IoIosArrowBack />  Rooms /</Link>
                <Link className='present' to='/luxroom'>Classic Double</Link>
            </div>
            
            <div className='room-list-wrapper'>
              
                  <Container data-Aos='fade-in'  className='image-wrapper'>
                        {/* <video className='imageTag' controls  muted >
                            <source src={Video} type='video/mp4' />
                        </video> */}

                        <Carousel interval={null} fade='true'  >
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                              src = {classic2}
                              alt = "" />
                          {/* <Carousel.Caption>
                            <h3>First slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                          </Carousel.Caption> */}
                          </Carousel.Item>
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                            src = {classic33}
                            alt = "" />
                            {/* <Carousel.Caption>
                            <h3>Second slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                          </Carousel.Caption> */}
                          </Carousel.Item>
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                            src = {classic4}
                            alt = "" />
                          {/* <Carousel.Caption>
                            <h3>Third slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                          </Carousel.Caption> */}
                          </Carousel.Item>
                    </Carousel> 
                      
                  </Container>
              
              
                  <div data-Aos='fade-in' className='features-wrapper1'>
                      <div className='content-header'>
                        <h3 className='executive-header'>CLASSIC DOUBLE</h3>
                        {/* <p>7 well appointed Classic King Size Rooms...</p> */}
                      </div>
                      {/* <div  className='items-wrapperlux'>
                      <Row>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              
                              <AiOutlineFundProjectionScreen size='30px' className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Smart TV</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              
                              <AiOutlineWifi size='30px' className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> High Speed Internet</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              
                              <BsSnow2 size='30px' className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Air Conditioner</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              
                              <GiOfficeChair size='30px' className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Office Table/Chair</span>
                            </div>
                          </Col>
                        </Row>
                        <Row className='SecondRow'>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              
                              <MdOutlineKingBed size='30px' className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> King Size Bed</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              
                              <BiDish size='40px' className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> 24/7 Room Service</span>
                            </div>
                          </Col>
                        </Row>
                        
                          
                      </div> */}
                      <div>
                          <p>
                          Our Classic Double Rooms have been carefully designed to offer you a 
                          comfortable retreat for your time with us. Cosy colours, wood tones, 
                          office table and large windows provide the perfect environment to relax, 
                          work and engage after an eventful day with folllowing facilities:
                          </p>
                          {/* <h6>
                            Here are rooms facilities:
                          </h6> */}
                          <div style={{display:'flex',justifyContent:'space-between'}}>
                          <ul>
                            <li>Air Conditioning</li>
                            <li>Queen Size Bed</li>
                            <li>Premium Linen & Bedding</li>
                            <li>Android TV with Netflix, Amazon Prime, etc.</li>
                            <li>Direct Dial Telephone</li>
                            <li>Bathroom with Shower</li>
                            <li>Razor Plug</li>
                            <li>Laundry Services (Fees are applied)</li>
                            <li>Extra Rollaway Bed (Chargeable)</li>
                            <li>24 Hrs Room Service</li>
                            

                          </ul>
                          <ul>
                            <li>Wake-Up Call</li>
                            <li>Office Table/Chair</li>
                            <li>Wi-Fi Internet Access Free of Charge</li>
                            <li>Bath Amenities – Herbal Soap & Shampoo</li>
                            <li>24 Hrs Hot Water</li>
                            <li>Closet with Lock</li>
                            <li>Daily Housekeeping</li>
                            <li>Modern Furnishing</li>
                            <li>Deep Room Sanitization</li>
                            <li>Complementary Water Bottles</li>
                            
                          </ul>
                          </div>
                          
                      </div>
                      {/* <div>

                      </div> */}


                      <div className='bookNowClassic'>
                          <a href='https://www.secure-booking-engine.com/accounts/FrmOnne118jtpxNpFLSXTA/properties/hahnewYRURcxpWB0cjHizA/booking-engine/web/source/4wsctBw6Oq6j-g9XuxeRzQ/cart/Cb-5qoivag2KMclH4qeG5Q/#/search'>
                            <Button className=
                            // 'bookNowlinkLuxRoom'
                            'bookNowlink'
                             style={{color:'#4d3319'}} to=''>BOOK NOW</Button>
                          </a>
                        
                      </div>
                  </div>
              
              

            </div>
          
        </section>
        </section>
        </div>
    )
}

export default LuxRoomPage
